import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { AccountInfo, PaginatedAccountResponse_$reflection, AccountInfo_$reflection } from "../Shared/ApiDataTypes.js";
import { obj_type, union_type, record_type, string_type, int32_type, bool_type, option_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { sortBy, map, append } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { some, unwrap, defaultArg, map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { join, interpolate, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { toUrlSafeString } from "../Utils.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { corsProps, testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { compareArrays, createObj, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { isMatch } from "../fable_modules/fable-library-js.4.24.0/RegExp.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableContainer, TableRow, Switch, Typography, TableCell, DialogActions, Button, DialogContentText, TextField, DialogContent, DialogTitle, Dialog, Checkbox, FormControlLabel } from "@mui/material";
import { empty as empty_1, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Account_formatPhone, isPtgEmail } from "../Shared/Shared.js";
import { SnackError, loadingIndicatorSmall, errorBanner } from "../ViewHelpers.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { EditForm as EditForm_2 } from "./UserEdit.js";
import { Components_Searchbar_25F45B5E } from "../Components/Searchbar.js";
import { Components_Button_Z1043B8E } from "../Components/Button.js";
import Add from "@mui/icons-material/Add";
import CheckCircle from "@mui/icons-material/CheckCircle";
import RemoveCircle from "@mui/icons-material/RemoveCircle";
import { Components_Table_Z1001F0B7, Components_TableHeaderCell_Z721C83C5 } from "../Components/Table.js";

class Model extends Record {
    constructor(Users, NoUsersOnLast, SelectedCustomer, AddForm, EditForm, ShowInactive, Filter, Page, ErrorMsg) {
        super();
        this.Users = Users;
        this.NoUsersOnLast = NoUsersOnLast;
        this.SelectedCustomer = SelectedCustomer;
        this.AddForm = AddForm;
        this.EditForm = EditForm;
        this.ShowInactive = ShowInactive;
        this.Filter = Filter;
        this.Page = (Page | 0);
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Kundeweb.Users.Model", [], Model, () => [["Users", option_type(array_type(AccountInfo_$reflection()))], ["NoUsersOnLast", bool_type], ["SelectedCustomer", option_type(int32_type)], ["AddForm", bool_type], ["EditForm", option_type(AccountInfo_$reflection())], ["ShowInactive", bool_type], ["Filter", string_type], ["Page", int32_type], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UsersResponse", "SelectCustomer", "ToggleAdd", "UserAdded", "ToggleEdit", "UserUpdated", "ToggleInactive", "UpdateFilter", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Kundeweb.Users.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [PaginatedAccountResponse_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", PaginatedAccountResponse_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", option_type(int32_type)]], [["Item", bool_type]], [["Item", AccountInfo_$reflection()]], [["Item", option_type(AccountInfo_$reflection())]], [["Item", AccountInfo_$reflection()]], [["Item", bool_type]], [["Item", string_type]], []]);
}

function init() {
    return new Model(undefined, false, undefined, false, undefined, false, "", 0, undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Users, model.NoUsersOnLast, msg.fields[0], model.AddForm, model.EditForm, model.ShowInactive, model.Filter, model.Page, model.ErrorMsg);
        case 2:
            return new Model(model.Users, model.NoUsersOnLast, model.SelectedCustomer, msg.fields[0], model.EditForm, model.ShowInactive, model.Filter, model.Page, model.ErrorMsg);
        case 3: {
            const x_3 = msg.fields[0];
            const matchValue = model.Users;
            if (matchValue != null) {
                return new Model(append([x_3], matchValue), model.NoUsersOnLast, model.SelectedCustomer, false, model.EditForm, model.ShowInactive, model.Filter, model.Page, model.ErrorMsg);
            }
            else {
                return new Model([x_3], model.NoUsersOnLast, model.SelectedCustomer, false, model.EditForm, model.ShowInactive, model.Filter, model.Page, model.ErrorMsg);
            }
        }
        case 4:
            return new Model(model.Users, model.NoUsersOnLast, model.SelectedCustomer, model.AddForm, msg.fields[0], model.ShowInactive, model.Filter, model.Page, model.ErrorMsg);
        case 5: {
            const x_5 = msg.fields[0];
            const matchValue_1 = model.Users;
            if (matchValue_1 != null) {
                return new Model(map((z_1) => {
                    if (z_1.Id === x_5.Id) {
                        return x_5;
                    }
                    else {
                        return z_1;
                    }
                }, matchValue_1), model.NoUsersOnLast, model.SelectedCustomer, model.AddForm, undefined, model.ShowInactive, model.Filter, model.Page, model.ErrorMsg);
            }
            else {
                return new Model([x_5], model.NoUsersOnLast, model.SelectedCustomer, model.AddForm, undefined, model.ShowInactive, model.Filter, model.Page, model.ErrorMsg);
            }
        }
        case 6:
            return new Model(model.Users, model.NoUsersOnLast, model.SelectedCustomer, model.AddForm, model.EditForm, msg.fields[0], model.Filter, 0, model.ErrorMsg);
        case 7:
            return new Model(model.Users, model.NoUsersOnLast, model.SelectedCustomer, model.AddForm, model.EditForm, model.ShowInactive, msg.fields[0], 0, model.ErrorMsg);
        case 8:
            return new Model(model.Users, model.NoUsersOnLast, model.SelectedCustomer, model.AddForm, model.EditForm, model.ShowInactive, model.Filter, model.Page, undefined);
        default: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                return new Model(model.Users, model.NoUsersOnLast, model.SelectedCustomer, model.AddForm, model.EditForm, model.ShowInactive, model.Filter, 0, "Kunne ikke laste brukere. Vennligst prøv igjen senere.");
            }
            else {
                const x = res.fields[0];
                const newUsers = (x.Page === 0) ? x.Entries : map_1((z) => append(z, x.Entries), model.Users);
                if (x.Entries.length === 0) {
                    return new Model(newUsers, true, model.SelectedCustomer, model.AddForm, model.EditForm, model.ShowInactive, model.Filter, model.Page, model.ErrorMsg);
                }
                else {
                    return new Model(newUsers, false, model.SelectedCustomer, model.AddForm, model.EditForm, model.ShowInactive, model.Filter, x.Page, model.ErrorMsg);
                }
            }
        }
    }
}

function fetchUsers(filter, showInactive, page, dispatch) {
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        const requestPath = (filter.length === 0) ? toText(interpolate("%P()?show-inactive=%b%P()&page=%i%P()", ["/api/account", showInactive, page])) : toText(interpolate("%P()?filter=%s%P()&show-inactive=%b%P()&page=%i%P()", ["/api/account", toUrlSafeString(filter.trim()), showInactive, page]));
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(PaginatedAccountResponse_$reflection(), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = extraCoders, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(PaginatedAccountResponse_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then((result_1) => Result_MapError(testRedirect, result_1)))).then((_arg_2) => {
            dispatch(new Message(0, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function UserForm(userFormInputProps) {
    let elements_2;
    const onClose = userFormInputProps.onClose;
    const updating = userFormInputProps.updating;
    const u = (updating == null) ? (new AccountInfo(-1, "", "", "", "47", "", false, false, false, true, true, false, false, undefined, [])) : updating;
    const patternInput = reactApi.useState(u);
    const user = patternInput[0];
    const updateUser = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setProcessing = patternInput_2[1];
    const patternInput_3 = reactApi.useState(true);
    const validCC = patternInput_3[0];
    const setValidCC = patternInput_3[1];
    const patternInput_4 = reactApi.useState(true);
    const validPhone = patternInput_4[0];
    const setValidPhone = patternInput_4[1];
    const ctx = reactApi.useContext(ctx_1);
    let isSuperAdmin;
    const matchValue = ctx.Session;
    isSuperAdmin = ((matchValue != null) && matchValue.IsSuperAdmin);
    const isDigitsOnly = (d_16) => isMatch(/^\d+$/gu, d_16);
    const genericCheckbox = (onChange, disabled, label, value_4) => MuiHelpers_createElement(FormControlLabel, [["labelPlacement", "end"], ["label", label], ["disabled", disabled], ["control", MuiHelpers_createElement(Checkbox, [["checked", value_4], ["onChange", (e) => {
        onChange(e.target.checked);
    }], ["color", "primary"], ["id", "checkbox-{label}"]])]]);
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_6, v) => {
        onClose(undefined);
    }], ["PaperProps", {
        style: {
            width: 400,
            minHeight: 300,
        },
    }], (elements_2 = toList(delay(() => append_1(singleton(MuiHelpers_createElement(DialogTitle, [["children", (updating != null) ? ctx.Locale.t("UserAdmin.Update") : ctx.Locale.t("UserAdmin.Add")]])), delay(() => {
        let elements;
        return append_1(singleton(MuiHelpers_createElement(DialogContent, [["sx", {
            display: "flex",
            flexDirection: "column",
            gap: 10 + "px",
        }], (elements = toList(delay(() => append_1(singleton(MuiHelpers_createElement(TextField, [["style", {
            marginTop: 5,
        }], ["label", ctx.Locale.t("Login.Email")], ["value", user.Email], ["color", "primary"], ["fullWidth", true], ["onChange", (e_1) => {
            const x_3 = e_1.target.value;
            updateUser(isPtgEmail(x_3) ? (new AccountInfo(user.Id, x_3, user.FirstName, user.LastName, user.PhoneCC, user.Phone, user.IsAdmin, user.IsSuperAdmin, true, true, true, user.TicketSystem, user.Enabled, user.Company, user.Groups)) : (new AccountInfo(user.Id, x_3, user.FirstName, user.LastName, user.PhoneCC, user.Phone, user.IsAdmin, user.IsSuperAdmin, false, user.TwoFactor, user.ForcedTfa, user.TicketSystem, user.Enabled, user.Company, user.Groups)));
        }]])), delay(() => {
            let elems;
            return append_1(singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                gap: 10 + "px ",
            }], (elems = [MuiHelpers_createElement(TextField, [["label", ctx.Locale.t("UserAdmin.FirstName")], ["value", user.FirstName], ["color", "primary"], ["fullWidth", true], ["onChange", (ev) => {
                updateUser(new AccountInfo(user.Id, user.Email, ev.target.value, user.LastName, user.PhoneCC, user.Phone, user.IsAdmin, user.IsSuperAdmin, user.IsPtg, user.TwoFactor, user.ForcedTfa, user.TicketSystem, user.Enabled, user.Company, user.Groups));
            }]]), MuiHelpers_createElement(TextField, [["label", ctx.Locale.t("UserAdmin.LastName")], ["value", user.LastName], ["color", "primary"], ["fullWidth", true], ["onChange", (ev_1) => {
                updateUser(new AccountInfo(user.Id, user.Email, user.FirstName, ev_1.target.value, user.PhoneCC, user.Phone, user.IsAdmin, user.IsSuperAdmin, user.IsPtg, user.TwoFactor, user.ForcedTfa, user.TicketSystem, user.Enabled, user.Company, user.Groups));
            }]])], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                let elems_1;
                return append_1(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                    gap: 10 + "px ",
                }], (elems_1 = [MuiHelpers_createElement(TextField, [["style", {
                    maxWidth: 80,
                }], ["inputProps", {
                    style: {
                        textAlign: "center",
                    },
                }], ["label", "+"], ["error", !validCC], ["defaultValue", user.PhoneCC], ["color", "primary"], ["onChange", (e_2) => {
                    const x_6 = e_2.target.value;
                    const trimmed = x_6.trim();
                    if (isDigitsOnly(trimmed) ? true : (trimmed === "")) {
                        updateUser(new AccountInfo(user.Id, user.Email, user.FirstName, user.LastName, x_6, user.Phone, user.IsAdmin, user.IsSuperAdmin, user.IsPtg, user.TwoFactor, user.ForcedTfa, user.TicketSystem, user.Enabled, user.Company, user.Groups));
                        setValidCC(true);
                    }
                    else {
                        setValidCC(false);
                    }
                }]]), MuiHelpers_createElement(TextField, [["sx", {
                    flexGrow: 1,
                }], ["label", ctx.Locale.t("UserAdmin.Phone")], ["defaultValue", user.Phone], ["error", !validPhone], ["color", "primary"], ["onChange", (e_3) => {
                    const x_7 = e_3.target.value;
                    const trimmed_1 = x_7.trim();
                    if (isDigitsOnly(trimmed_1) ? true : (trimmed_1 === "")) {
                        updateUser(new AccountInfo(user.Id, user.Email, user.FirstName, user.LastName, user.PhoneCC, x_7, user.IsAdmin, user.IsSuperAdmin, user.IsPtg, user.TwoFactor, user.ForcedTfa, user.TicketSystem, user.Enabled, user.Company, user.Groups));
                        setValidPhone(true);
                    }
                    else {
                        setValidPhone(false);
                    }
                }]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append_1((updating != null) ? singleton(genericCheckbox((x_8) => {
                    updateUser(new AccountInfo(user.Id, user.Email, user.FirstName, user.LastName, user.PhoneCC, user.Phone, user.IsAdmin, user.IsSuperAdmin, user.IsPtg, user.TwoFactor, user.ForcedTfa, user.TicketSystem, x_8, user.Company, user.Groups));
                }, false, ctx.Locale.t("Active"), user.Enabled)) : empty_1(), delay(() => append_1(singleton(genericCheckbox((x_9) => {
                    updateUser(new AccountInfo(user.Id, user.Email, user.FirstName, user.LastName, user.PhoneCC, user.Phone, user.IsAdmin, user.IsSuperAdmin, user.IsPtg, user.TwoFactor, user.ForcedTfa, x_9, user.Enabled, user.Company, user.Groups));
                }, false, ctx.Locale.t("UserAdmin.TicketSystemAccess"), user.TicketSystem)), delay(() => append_1(singleton(genericCheckbox((x_10) => {
                    updateUser(new AccountInfo(user.Id, user.Email, user.FirstName, user.LastName, user.PhoneCC, user.Phone, x_10, user.IsSuperAdmin, user.IsPtg, user.TwoFactor, user.ForcedTfa, user.TicketSystem, user.Enabled, user.Company, user.Groups));
                }, !isSuperAdmin, ctx.Locale.t("UserAdmin.IsAdmin"), user.IsAdmin)), delay(() => append_1(singleton(genericCheckbox((x_11) => {
                    updateUser(new AccountInfo(user.Id, user.Email, user.FirstName, user.LastName, user.PhoneCC, user.Phone, user.IsAdmin, user.IsSuperAdmin, user.IsPtg, x_11, user.ForcedTfa, user.TicketSystem, user.Enabled, user.Company, user.Groups));
                }, user.IsPtg, ctx.Locale.t("UserAdmin.TfaCanChange"), user.TwoFactor)), delay(() => append_1(singleton(genericCheckbox((x_12) => {
                    updateUser(new AccountInfo(user.Id, user.Email, user.FirstName, user.LastName, user.PhoneCC, user.Phone, user.IsAdmin, user.IsSuperAdmin, user.IsPtg, user.TwoFactor, x_12, user.TicketSystem, user.Enabled, user.Company, user.Groups));
                }, user.IsPtg, ctx.Locale.t("UserAdmin.TfaCannotChange"), user.ForcedTfa)), delay(() => singleton(errorBanner(patternInput_1[0], () => {
                    setErrMsg(undefined);
                }))))))))))))));
            }));
        })))), ["children", reactApi.Children.toArray(Array.from(elements))])])), delay(() => append_1((updating == null) ? singleton(MuiHelpers_createElement(DialogContentText, [["style", {
            marginTop: 10,
            marginBottom: 0,
            padding: ((0 + "px ") + 24) + "px",
        }], ["children", ctx.Locale.t("UserAdmin.EmailDesc")]])) : empty_1(), delay(() => {
            let children;
            return singleton((children = toList(delay(() => (patternInput_2[0] ? singleton(loadingIndicatorSmall()) : append_1(singleton(MuiHelpers_createElement(Button, [["size", "small"], ["color", "primary"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_8) => {
                onClose(undefined);
            }]])), delay(() => singleton(MuiHelpers_createElement(Button, [["size", "small"], ["color", "primary"], ["variant", "contained"], ["disabled", ((user.Email.trim().length === 0) ? true : !validCC) ? true : !validPhone], ["children", (updating != null) ? ctx.Locale.t("Update") : ctx.Locale.t("Add")], ["onClick", (_arg_9) => {
                const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let body, decoder, data_1, caseStrategy_3, extra_3, data_4, decoder_3, data_5, caseStrategy_12, extra_12;
                    if (user.Email.length !== 0) {
                        setErrMsg(undefined);
                        setProcessing(true);
                        return ((updating == null) ? ((body = Auto_generateBoxedEncoder_437914C6(AccountInfo_$reflection(), undefined, undefined, undefined)(user), (decoder = Auto_generateBoxedDecoder_Z6670B51(AccountInfo_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                            let properties_2;
                            try {
                                const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/account/edit", properties_3).then((_arg) => {
                                    let response_1, decoder_1_1;
                                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(AccountInfo_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                                        let matchValue_1;
                                        return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                                }))));
                                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                            }
                            catch (exn) {
                                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                            }
                        })())))))) : ((data_4 = some(Auto_generateBoxedEncoder_437914C6(AccountInfo_$reflection(), undefined, undefined, undefined)(user)), (decoder_3 = Auto_generateBoxedDecoder_Z6670B51(AccountInfo_$reflection(), undefined, undefined), (data_5 = data_4, (caseStrategy_12 = undefined, (extra_12 = undefined, (() => {
                            let properties_6;
                            try {
                                const properties_3_1 = Helper_withProperties(corsProps, (properties_6 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map_1((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_12), unwrap(extra_12))(data_1_2))]), properties_6), data_5), properties_6)));
                                const pr_1 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/account/edit", properties_3_1).then((_arg_2) => {
                                    let response_3, decoder_1_2;
                                    return ((response_3 = _arg_2, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(AccountInfo_$reflection(), unwrap(caseStrategy_12), unwrap(extra_12))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_3.text().then((_arg_3) => {
                                        let matchValue_2;
                                        return Promise.resolve((matchValue_2 = fromString(uncurry2(decoder_1_2), _arg_3), (matchValue_2.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_2.fields[0]])])) : (new FSharpResult$2(0, [matchValue_2.fields[0]]))));
                                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                                }))));
                                return pr_1.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])]))));
                            }
                            catch (exn_1) {
                                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
                            }
                        })()))))))).then((_arg_4) => {
                            const res = _arg_4;
                            if (res.tag === 0) {
                                onClose(res.fields[0]);
                                return Promise.resolve();
                            }
                            else {
                                const err = res.fields[0];
                                setErrMsg((err.tag === 2) ? (((err.fields[0].status) === 400) ? ctx.Locale.t("Login.InvalidEmail") : (((err.fields[0].status) === 404) ? ctx.Locale.t("UserAdmin.UpdateNotFound") : (((err.fields[0].status) === 409) ? ctx.Locale.t("UserAdmin.EmailTaken") : ((updating != null) ? ctx.Locale.t("UserAdmin.UpdateFailed") : ctx.Locale.t("UserAdmin.AddFailed"))))) : ((updating != null) ? ctx.Locale.t("UserAdmin.UpdateFailed") : ctx.Locale.t("UserAdmin.AddFailed")));
                                setProcessing(false);
                                return Promise.resolve();
                            }
                        });
                    }
                    else {
                        return Promise.resolve();
                    }
                }));
                pr_2.then();
            }]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children))]])));
        }))));
    })))), ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

function th$0027(txt) {
    return MuiHelpers_createElement(TableCell, [["style", {
        textAlign: "center",
    }], ["variant", "head"], ["children", txt]]);
}

export function View() {
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const arg_1 = init();
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const isAdmin = defaultArg(map_1((s) => {
        if (s.IsAdmin) {
            return true;
        }
        else {
            return s.IsSuperAdmin;
        }
    }, ctx.Session), false);
    const dependencies = [model_1.Filter, model_1.ShowInactive];
    reactApi.useEffect(() => {
        if (isAdmin) {
            fetchUsers(model_1.Filter, model_1.ShowInactive, model_1.Page, dispatch);
        }
    }, dependencies);
    if (!isAdmin) {
        return defaultOf();
    }
    else {
        const xs_6 = toList(delay(() => append_1(singleton(createElement(SnackError, {
            errMsg: unwrap(model_1.ErrorMsg),
            dismiss: () => {
                dispatch(new Message(8, []));
            },
        })), delay(() => append_1(model_1.AddForm ? singleton(createElement(UserForm, {
            onClose: (newUser) => {
                if (newUser != null) {
                    dispatch(new Message(3, [newUser]));
                }
                else {
                    dispatch(new Message(2, [false]));
                }
            },
        })) : empty_1(), delay(() => {
            let matchValue, ef;
            return append_1((matchValue = model_1.EditForm, (matchValue != null) ? ((ef = matchValue, singleton(createElement(EditForm_2, {
                account: ef,
                onClose: (updatedUser) => {
                    if (updatedUser != null) {
                        dispatch(new Message(5, [updatedUser]));
                    }
                    else {
                        dispatch(new Message(4, [undefined]));
                    }
                },
            })))) : singleton(defaultOf())), delay(() => append_1(singleton(MuiHelpers_createElement(Typography, [["variant", "h1"], ["children", ctx.Locale.t("UserAdmin.Users")]])), delay(() => {
                let elems_6, elems_5;
                return singleton(createElement("div", createObj(ofArray([["className", join(" ", ["rounded-container"])], ["style", {
                    width: 100 + "%",
                    height: ("calc(" + "100vh - 120px - 30px - 60px - 30px") + ")",
                }], (elems_6 = [createElement("div", createObj(ofArray([["className", join(" ", ["main-tab-container-inner"])], (elems_5 = toList(delay(() => {
                    let elems_1, elems;
                    return append_1(singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        width: 100 + "%",
                    }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "row",
                        alignSelf: "center",
                        flexGrow: 1,
                        gap: 30 + "px",
                    }], (elems = [createElement("div", {
                        style: {
                            flexBasis: 320 + "px",
                        },
                        children: createElement(Components_Searchbar_25F45B5E, {
                            placeholder: "Søk på navn eller epost",
                            onChange: (test) => {
                                dispatch(new Message(7, [test.target.value]));
                            },
                        }),
                    }), MuiHelpers_createElement(FormControlLabel, [["label", ctx.Locale.t("UserAdmin.ShowInactive")], ["labelPlacement", "end"], ["control", MuiHelpers_createElement(Switch, [["color", "primary"], ["checked", model_1.ShowInactive], ["onChange", (e) => {
                        dispatch(new Message(6, [e.target.checked]));
                    }]])]])], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(Components_Button_Z1043B8E, {
                        text: ctx.Locale.t("UserAdmin.Add"),
                        onClick: (_arg_2) => {
                            dispatch(new Message(2, [!model_1.AddForm]));
                        },
                        startIcon: (props_5) => {
                            const props_7 = createObj(props_5);
                            return react.createElement(Add, props_7);
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                        let children_3;
                        const matchValue_1 = model_1.Users;
                        if (matchValue_1 != null) {
                            const users = matchValue_1;
                            const cell = (text) => MuiHelpers_createElement(TableCell, [["style", {
                                padding: ((((((16 + "px ") + 16) + "px ") + 16) + "px ") + 16) + "px",
                            }], ["variant", "body"], ["size", "small"], ["children", MuiHelpers_createElement(Typography, [["variant", "body2"], ["paragraph", false], ["children", text]])]]);
                            const checkedIcon = (b) => {
                                let props_12, props_14;
                                return MuiHelpers_createElement(TableCell, [["style", createObj(toList(delay(() => append_1(singleton(["padding", ((((((16 + "px ") + 16) + "px ") + 16) + "px ") + 16) + "px"]), delay(() => (!b ? singleton(["color", "#aaa"]) : empty_1()))))))], ["variant", "body"], ["children", b ? ((props_12 = {}, react.createElement(CheckCircle, props_12))) : ((props_14 = {}, react.createElement(RemoveCircle, props_14)))]]);
                            };
                            const headers = map((label) => createElement(Components_TableHeaderCell_Z721C83C5, {
                                label: label,
                            }), ["Navn", "Selskap", "Epost", "Telefonnummer", "Aktiv", "Admin", "Ticketsenter", "To-faktor"]);
                            const tableRows = map((user) => {
                                let elements;
                                const companyName = defaultArg(map_1((_arg_3) => _arg_3.Name, user.Company), "");
                                return MuiHelpers_createElement(TableRow, [["style", {
                                    cursor: "pointer",
                                }], ["onClick", (_arg_4) => {
                                    console.debug("Clicked user row", user);
                                    dispatch(new Message(4, [user]));
                                }], ["hover", true], (elements = [cell(`${user.FirstName} ${user.LastName}`), cell(companyName), cell(user.Email), cell(Account_formatPhone(user.PhoneCC, user.Phone)), checkedIcon(user.Enabled), checkedIcon(user.IsAdmin), checkedIcon(user.TicketSystem), checkedIcon(user.TwoFactor)], ["children", reactApi.Children.toArray(Array.from(elements))])]);
                            }, sortBy((x) => [!x.Enabled, x.Email], users, {
                                Compare: compareArrays,
                            }));
                            return append_1(singleton((children_3 = singleton_1(createElement(Components_Table_Z1001F0B7, {
                                headers: headers,
                                rows: tableRows,
                            })), MuiHelpers_createElement(TableContainer, [["children", reactApi.Children.toArray(Array.from(children_3))]]))), delay(() => {
                                let elems_4;
                                return (((users.length % 25) === 0) && !model_1.NoUsersOnLast) ? singleton(createElement("div", createObj(ofArray([["style", {
                                    width: 100 + "%",
                                    marginTop: 10,
                                    display: "flex",
                                    justifyContent: "center",
                                }], (elems_4 = [MuiHelpers_createElement(Button, [["onClick", (_arg_5) => {
                                    fetchUsers(model_1.Filter, model_1.ShowInactive, model_1.Page + 1, dispatch);
                                }], ["size", "small"], ["color", "primary"], ["variant", "contained"], ["children", ctx.Locale.t("LoadMore")]])], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty_1();
                            }));
                        }
                        else {
                            return singleton(loadingIndicatorSmall());
                        }
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
            }))));
        }))))));
        return react.createElement(react.Fragment, {}, ...xs_6);
    }
}

